import styled from 'styled-components';

export const FilterMedia = styled.div`
  .table {
    .header {
      display: none;
    }
    .group {
      background-color: #f9f9f9 !important;
    }
    .rows {
      cursor: pointer;
    }
  }
  .headline {
    /* link color */
    color: #3847aa;
  }
`;
